import type { MigrationStrategies } from "./_types/migration-strategies";

export const CLINIC_INSURANCE_MIGRATION_STRATEGIES: MigrationStrategies = {};
